import { useEffect, useRef, useState } from "react";
import SignalService from "../services/SignalService";
import { apiLink } from "../constants/env";

export function useSignalR(
  hubString,
  connectionString,
) {
  const [dadoAtualizado, setDadoAtualizado] = useState(null);
  const connectionRef = useRef(null);
  
  useEffect(() => {
    const connection = SignalService.startConnection(`${apiLink()}${hubString}`);

    connectionRef.current = connection;

    connection
      .start()
      .then(() => {
        connection.on(connectionString, (message) => {
          setDadoAtualizado(message);
        });
      })
      .catch((e) => console.error("Conexão falhou:", e));

    return () => {
      connection.off(connectionString);
      connection.stop();
    };
  }, [apiLink,  hubString, connectionString, connectionRef]);

  return { dadoAtualizado, setDadoAtualizado };
}
